// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import SvgIconStyle from '../../components/SvgIconStyle';

// Restore ICONS definition
const getIcon = (name) => (
  <SvgIconStyle src={`/static/icons/navbar/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
);

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  customer: getIcon('ic_customer'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  booking: getIcon('ic_booking'),
  user: getIcon('ic_user')
};

// Accepts an optional infoMap: { [title]: infoComponent }
const getSidebarConfig = ({ exercise, infoMap = {}, userId }) => {
  const numberExercise = Number(exercise);
  const isDeprecated = numberExercise > 25;
  const canViewLogs = Number(userId) === 1 || Number(userId) === 2;
  let childrenInvoices = [];
  let childrenReceipts = [];

  if (!isDeprecated) {
    childrenInvoices = [
      { title: 'Serie V', path: `${PATH_DASHBOARD.invoice.series}V` },
      { title: 'Serie C', path: `${PATH_DASHBOARD.invoice.series}C` },
      { title: 'Serie T', path: `${PATH_DASHBOARD.invoice.series}T` }
    ];

    childrenReceipts = [
      { title: 'Serie A', path: `${PATH_DASHBOARD.receipt.series}A` },
      { title: 'Serie C', path: `${PATH_DASHBOARD.receipt.series}C` },
      { title: 'Serie Z', path: `${PATH_DASHBOARD.receipt.series}Z` }
    ];
  } else {
    childrenInvoices = [
      { title: 'Serie V', path: `${PATH_DASHBOARD.invoice.series}V` },
      { title: 'Serie T', path: `${PATH_DASHBOARD.invoice.series}T` }
    ];

    childrenReceipts = [
      { title: 'Serie A', path: `${PATH_DASHBOARD.receipt.series}A` },
      { title: 'Serie Z', path: `${PATH_DASHBOARD.receipt.series}Z` }
    ];
  }

  return [
    // GENERAL
    // ----------------------------------------------------------------------
    {
      subheader: 'general',
      items: [
        {
          title: 'dashboard',
          path: PATH_DASHBOARD.general.app,
          icon: ICONS.dashboard
        },
        {
          title: 'pedidos',
          path: PATH_DASHBOARD.order.root,
          icon: ICONS.analytics,
          info: infoMap.pedidos
        },
        {
          title: 'facturas',
          path: PATH_DASHBOARD.invoice.root,
          icon: ICONS.ecommerce,
          children: childrenInvoices
        },
        {
          title: 'Autofacturas',
          path: PATH_DASHBOARD.autoInvoice.root,
          icon: ICONS.banking,
          children: [{ title: 'Serie Z', path: `${PATH_DASHBOARD.invoice.series}Z` }]
        },
        {
          title: 'f. rectificativas',
          path: PATH_DASHBOARD.amend.root,
          icon: ICONS.banking,
          children: [
            { title: 'Abono Facturas', path: `${PATH_DASHBOARD.amend.series}R` },
            { title: 'Abono Tickets', path: `${PATH_DASHBOARD.amend.series}TR` }
          ]
        },
        {
          title: 'albaranes',
          path: PATH_DASHBOARD.receipt.root,
          icon: ICONS.calendar,
          children: childrenReceipts
        },
        {
          title: 'F.Proforma',
          path: PATH_DASHBOARD.quote.root,
          icon: ICONS.calendar,
          children: [{ title: 'Serie P', path: `${PATH_DASHBOARD.quote.series}P` }]
        }
      ]
    },
    // MANAGEMENT
    // ----------------------------------------------------------------------
    {
      subheader: 'Mantenimiento',
      items: [
        // MANAGEMENT : USER
        /* {
          title: 'usuarios',
          path: PATH_DASHBOARD.user.root,
          icon: ICONS.user,
          children: [
            { title: 'Listado', path: PATH_DASHBOARD.user.list },
            { title: 'Consultas', path: PATH_DASHBOARD.user.query }
          ]
        }, */

        // MANAGEMENT : CUSTOMER
        {
          title: 'clientes',
          path: PATH_DASHBOARD.customer.list,
          icon: ICONS.customer,
          children: [
            { title: 'Listado', path: PATH_DASHBOARD.customer.list },
            { title: 'Consultas', path: PATH_DASHBOARD.customer.reports }
          ]
        },

        // MANAGEMENT : PRODUCT
        {
          title: 'productos',
          path: PATH_DASHBOARD.product.list,
          icon: ICONS.cart
        },
        {
          title: 'listados',
          path: PATH_DASHBOARD.report.root,
          icon: ICONS.analytics
        },
        ...(canViewLogs
          ? [
              {
                title: 'Logs',
                path: PATH_DASHBOARD.logs.root,
                icon: ICONS.analytics
              }
            ]
          : []),
        // MANAGEMENT : SETTINGS
        {
          title: 'configuración',
          path: PATH_DASHBOARD.settings.root,
          icon: ICONS.kanban
        }
      ]
    }
  ];
};

export default getSidebarConfig;
